(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Sticky / scroll-driven header behavior has been intentionally removed. The
  // header scrolls naturally with the page, so there is no scroll listener and
  // no <sticky-header> custom element. The code below only handles responsive
  // truncation of the inline menu and is unrelated to scroll visibility.
  const headerMenuOverflowMq = window.matchMedia('(min-width: 990px)');

  function resetHeaderMenuOverflow(header) {
    if (!header) return;
    header.classList.remove('header--menu-truncated');
    header.querySelectorAll('.header__inline-menu li.header__menu-item--hidden').forEach((item) => {
      item.classList.remove('header__menu-item--hidden');
    });
  }

  function truncateHeaderMenuOverflow(header) {
    const menu = header.querySelector('.header__inline-menu .list-menu--inline');
    const icons = header.querySelector('.header__icons');
    const logo = header.querySelector('.header__heading-link') || header.querySelector('.header__heading');

    if (!menu || !icons || !logo) return;

    const items = [...menu.children];

    resetHeaderMenuOverflow(header);

    const minLeft = () => logo.getBoundingClientRect().right + 8;
    const maxRight = () => icons.getBoundingClientRect().left - 8;

    const menuFits = () => {
      const visibleItems = items.filter((item) => !item.classList.contains('header__menu-item--hidden'));
      if (!visibleItems.length) return true;

      const firstRect = visibleItems[0].getBoundingClientRect();
      const lastRect = visibleItems[visibleItems.length - 1].getBoundingClientRect();

      return firstRect.left >= minLeft() && lastRect.right <= maxRight();
    };

    let guard = items.length;

    while (!menuFits() && guard > 0) {
      guard -= 1;
      let hiddenItem = false;

      for (let i = items.length - 1; i >= 0; i -= 1) {
        if (!items[i].classList.contains('header__menu-item--hidden')) {
          items[i].classList.add('header__menu-item--hidden');
          hiddenItem = true;
          break;
        }
      }

      if (!hiddenItem) break;
    }

    if (items.some((item) => item.classList.contains('header__menu-item--hidden'))) {
      header.classList.add('header--menu-truncated');
    }
  }

  function updateHeaderMenuOverflow() {
    const header = document.querySelector('.header.header--compact');

    if (!header || !header.querySelector('.header__inline-menu')) return;

    if (!headerMenuOverflowMq.matches) {
      resetHeaderMenuOverflow(header);
      return;
    }

    truncateHeaderMenuOverflow(header);
  }

  function initHeaderMenuOverflow() {
    let resizeTimer;

    updateHeaderMenuOverflow();

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateHeaderMenuOverflow, 100);
    });

    headerMenuOverflowMq.addEventListener('change', updateHeaderMenuOverflow);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateHeaderMenuOverflow);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.header--compact')) {
        updateHeaderMenuOverflow();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderMenuOverflow);
  } else {
    initHeaderMenuOverflow();
  }

  } catch(e) { console.error(e); }
})();
})();
